// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_Mk0","cls2":"LoswpPackPitch-cls2_DG6 LoswpPackPitch-cls1_Mk0"};